export const TERMS_LINK = 'https://www.productscience.ai/terms'
export const PRIVACY_LINK = 'https://www.productscience.ai/privacy'
